import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { eraseFilters } from "./utils";
import styles from "./styles.scss";

function EraseButton({ filter, erase }: Props) {
  const { t } = useTranslation();

  return (
    <button
      className={styles.eraseButton}
      onClick={() => erase(eraseFilters(filter))}
    >
      {t("common.filterMenu.erase")}
    </button>
  );
}

export { EraseButton };
